module.exports = __webpack_public_path__ + "img/forum-min-title.53e123a0.png";